import { Divider } from 'antd';
import styled, { css } from 'styled-components';
import { useAppSelector } from '../../methods/redux/hooks';

const Style = styled.div`
	& .address {
		word-wrap: break-word;
	}

	& .network {
		display: inline-block;
		margin-right: 20px;
		font-style: italic;
	}
`;

const BalanceStyle = styled.div<{ negative: boolean }>`
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 7px 0;
	margin-right: 10px;
	border-bottom: 1px solid #eee;

	${(p) =>
		p.negative &&
		css`
			color: red;
			font-weight: 600;
		`}

	& img {
		width: 32px;
		height: 32px;
	}

	& .usdValue {
		font-size: 11px;
	}

	& .balance {
		font-size: 15px;
	}

	& > div:first-child {
		margin-right: 5px;
		display: flex;
		align-items: center;

		& > div:first-child {
			margin-right: 5px;
		}
	}
`;

const VirtualDepositAccounts = () => {
	const { walletBalance } = useAppSelector((store) => store.userProfile);

	return (
		<Style>
			<Divider />
			<p style={{ marginBottom: '16px' }}>
				<strong>Virtual Deposit Accounts:</strong>
			</p>
			{walletBalance?.virtualDepositAccounts?.length > 0 ? (
				<div>
					{walletBalance?.virtualDepositAccounts?.map((item: any) => (
						<BalanceStyle key={item?._id}>
							<div
								style={{
									display: 'block',
									width: '100%',
									padding: '10px 0',
									borderBottom: '1px solid #d7d7d4',
								}}
							>
								<p className="balance">{item?.bankName}</p>
								<p className="usdValue">
									{item?.accountName}- {item?.accountNumber}
								</p>
							</div>
						</BalanceStyle>
					))}
				</div>
			) : (
				<div>
					<p style={{ textAlign: 'center' }}>
						No virtual deposit accounts available
					</p>
				</div>
			)}
		</Style>
	);
};

export default VirtualDepositAccounts;
